export enum ApiErrors {
  /*
    Occurs in registerAdmin
    Happens if admin password is incorrect
  */
  ADMIN_INVALID_KEY = 'admin_invalid_key',

  /*
    Occurs in createInvestment
    Happens if desired amount exceeds maximum amount per investment.
  */
  INVEST_AMOUNT_EXCEEDS_MAXIMAL = 'invest_amount_exceeds_max',

  /*
    Occurs in createInvestment
    Happens if desired amount exceeds amount of remining shares.
  */
  INVEST_AMOUNT_EXCEEDS_SHARES = 'invest_amount_exceeds_shares',

  /*
    Occurs in createInvestment
    Happens if desired amount is lower than minimum amount per investment.
  */
  INVEST_AMOUNT_LOWER_MINIMAL = 'invest_amount_lower_min',

  /*
    Occurs in updateInvestment
    Happens if investment status isn't correct
  */
  INVEST_INVALID_STATUS = 'invest_invalid_status',

  /*
    Occurs in createInvestment, updateInvestment
    Happens if investment status isn't correct
  */
  INVEST_NO_ACTIVE_USER_WALLET = 'invest_no_active_user_wallet',

  /*
    Occurs in updateInvestment
    Happens if investment is older than 14 days
  */
  INVEST_TOO_OLD = 'invest_too_old',

  /*
    Happens if createUser was already called before
    Occurs in createUser mutation
  */
  USER_ALREADY_CREATED = 'user_already_created',

  /*
    Happens if user idNowStatus is not NEEDS_APPROVAL
    Occurs in approveUser mutation
  */
  USER_APPROVAL_NOT_NEEDED = 'user_approval_not_needed',

  /*
    Occurs in registerUser & registerAdmin mutation
    Happens if provided email is already used.
  */
  USER_DUPLICATE_EMAIL = 'user_duplicate_email',

  /*
    Happens if (idDocumentType, idDocumentNumber, idDocumentCountry) triple is already used
    Occurs in createUser mutation
  */
  USER_DUPLICATE_IDENTIFICATION = 'user_duplicate_identification',

  /*
    Occurs in loginUser
    Happens if there is no user found by provided credentials
  */
  USER_INVALID_CREDENTIALS = 'user_invalid_credentials',

  /*
    Occurs in addInvestment
    Happens if user is not IDNow confirmed
  */
  USER_INVALID_IDNOWSTATUS = 'user_invalid_idnowstatus',

  /*
    User wasn't found
    Occurs in getCurrendUser query
  */
  USER_NOT_FOUND = 'user_not_found',

  /*
    Occurs in deletePayment
    Happens if user is trying to remove default payment
  */
  USER_PAYMENT_DEFAULT = 'user_payment_default',

  /*
    Occurs in deletePayment, addInvestment and updateUser
    deletePayment - Happens if payment wasn't found by provided id
    addInvestment - Happens if payment wasn't found by provided id
    updateUser - Happens if default payment isn't in payment_accounts
  */
  USER_PAYMENT_NOT_FOUND = 'user_payment_not_found',

  /*
    Occurs in updateUser mutation
    Happens if user's wallet already exists
  */
  USER_WALLET_ALREADY_CREATED = 'user_wallet_already_created',

  /*
    Occurs in createSale
    Happens if:
    - start date is in past or
    - end date is in past or
    - end date is before start date
  */
  SALE_DATE_RANGE_INVALID = 'sale_date_range_invalid',

  /*
    Occurs in createSale
    Happens if provided fileId (s3 object key) wasn't found in s3 bucket
  */
  SALE_IMAGE_NOT_FOUND = 'sale_image_not_found',

  /*
    Occurs in createSale
    Happens if provided name is already used
  */
  SALE_NAME_TAKEN = 'sale_name_taken',

  /*
    Occurs in deleteSale
    Happens if trying to delete non-existing sale
  */
  SALE_NOT_FOUND = 'sale_not_found',

  /*
    Occurs in createSale, updateInvestment
    Happens if:
    - sale token's creation failed
    - sale token's minting failed
    - sale token's burning failed
  */
  TOKEN_OPERATION_FAILED = 'token_operation_failed',
}
